module.exports = __webpack_public_path__ + "static/media/thermometer-three-quarters.92f558a9.svg";